import dompurify from 'dompurify';
import type { ElementType } from 'react';

import type { ComponentWithoutRefAsPropParams } from '@bank/utils';

export type InnerHtmlProps<As extends ElementType = 'span'> =
  ComponentWithoutRefAsPropParams<As> & {
    html: string;
  };

/**
 * Renders an HTML string, sanitized with DOMPurify.
 *
 * `dangerouslySetInnerHTML` is intentionally omitted from the props so the
 * sanitizing path is the only way to inject markup.
 */
export const InnerHtml = <As extends ElementType = 'span'>(
  props: Omit<InnerHtmlProps<As>, 'dangerouslySetInnerHTML'>,
) => {
  const { as: Comp = 'span', html, ...rest } = props;

  return (
    <Comp
      {...rest}
      dangerouslySetInnerHTML={{
        __html: dompurify.sanitize(html),
      }}
    />
  );
};
